import get from 'lodash/fp/get';

export const SIDEBAR_DEFAULT_WIDTH = 470;
export const SIDEBAR_MIN_WIDTH = 350;
export const SIDEBAR_MODE_BREAKPOINT_MAP = 990;
export const SIDEBAR_MODE_BREAKPOINT_TABLE = 1440;

const BASE = 'app';

export const getSidebarTabId = get(`${BASE}.sidebar.tabId`);
